module.exports = __webpack_public_path__ + "img/DJI_0026.0f7a2741.gif";